module.exports = __webpack_public_path__ + "img/hospitalario_puerta-de-hierro.aa6a6d01.jpg";